/**
 * Payment Reason Enum
 *
 * Defines the available payment reason codes.
 * These codes are used to categorize payment types in the system.
 */
export enum PaymentReasonEnum {
  FACTURA_AVE = "FACTURA_AVE", // Factura AVE payment type
  // Add other payment reason codes as needed by the business
}
